module.exports = __webpack_public_path__ + "static/img/dMRI5.21325fb4.png";